enum ERouteAccountant {
	PATH_APP_LAYOUT = '/',
	PATH_DASHBOARD = '/',
	PATH_CLIENTS = '/clients',
	PATH_ACCOUNT = '/account',
	PATH_WORKSPACE = '/workspaces/:workspaceId',
	PATH_INVOICES = '/workspaces/:workspaceId/invoices',
	PATH_EXPENSES = '/workspaces/:workspaceId/expenses',
	PATH_TRANSACTIONS = '/workspaces/:workspaceId/transactions',
	PATH_INTEGRATIONS = '/workspaces/:workspaceId/integrations',
}

export const workspacePath = (workspaceId: string, section: 'invoices' | 'expenses' | 'transactions' | 'integrations' = 'invoices') => `/workspaces/${workspaceId}/${section}`

export default ERouteAccountant
